<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("date-range-picker", {
    staticClass: "form-control date-pickr",
    class: !_vm.isEditable ? "disable-date" : "",
    attrs: {
      "auto-apply": true,
      timePicker: false,
      opens: "center",
      "show-dropdowns": true,
      ranges: false,
      showWeekNumbers: false,
      singleDatePicker: _vm.singleDatePicker,
      disabled: !_vm.isEditable,
      maxDate: _vm.maxDate,
      minDate: _vm.minDate,
      placeholder: _vm.placeholder,
    },
    on: { update: _vm.updateValues },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function (picker) {
          return [
            _vm.dateRange.startDate
              ? _c("span", [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dateFormate(
                            picker.startDate || _vm.dateRange.startDate
                          )
                        )
                    ),
                  ]),
                  !_vm.singleDatePicker
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            "" +
                              (_vm.dateRange.endDate || picker.endDate
                                ? " to " +
                                  _vm.dateFormate(
                                    picker.endDate || _vm.dateRange.endDate
                                  )
                                : " ")
                          )
                        ),
                      ])
                    : _vm._e(),
                ])
              : _c("span", { staticClass: "date-placeholder" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("ad.date-pace")))]),
                  !_vm.singleDatePicker
                    ? _c("span", [
                        _vm._v("- " + _vm._s(_vm.$t("ad.date-pace")) + " "),
                      ])
                    : _vm._e(),
                ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange",
    },
  })
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/DatePicker.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import vue2_daterange_picker from 'vue2-daterange-picker';
import vue2_daterange_picker_dist_vue2_daterange_picker_css from 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    DateRangePicker: vue2_daterange_picker
  },
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: ""
      }
    };
  },
  props: {
    value: {
      default: null,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true
    },
    singleDatePicker: {
      type: Boolean,
      required: false,
      default: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxDate: {
      default: undefined
    },
    minDate: {
      default: undefined
    }
  },
  watch: {
    value(newValue, oldVal) {
      if (oldVal !== newValue) {
        if (newValue && newValue.length) {
          if (this.singleDatePicker) {
            this.dateRange = {
              startDate: newValue,
              endDate: ""
            };
          } else if (!this.singleDatePicker) {
            const [startDateString, endDateString] = newValue.split(" to ");
            const startDate = new Date(startDateString);
            const endDate = endDateString ? new Date(endDateString) : new Date();
            this.dateRange = {
              startDate,
              endDate
            };
          }
          this.updateValues(this.dateRange);
          this.parameterChanged();
        } else {
          this.dateRange = {
            startDate: "",
            endDate: ""
          };
        }
      }
    }
  },
  mounted() {
    if (this.value && this.value.length) {
      if (this.value && this.value.length) {
        if (this.singleDatePicker) {
          this.dateRange = {
            startDate: this.value,
            endDate: ""
          };
        } else if (!this.singleDatePicker) {
          const [startDateString, endDateString] = this.value.split(" to ");
          const startDate = new Date(startDateString);
          const endDate = endDateString ? new Date(endDateString) : new Date();
          this.dateRange = {
            startDate,
            endDate
          };
        }
        this.updateValues(this.dateRange);
        this.parameterChanged();
      } else {
        this.dateRange = {
          startDate: "",
          endDate: ""
        };
      }
    }
  },
  methods: {
    parameterChanged() {
      if (this.dateRange.startDate) {
        if (!this.singleDatePicker) {
          let dateRange = this.dateRange;
          dateRange.startDate = new Date(dateRange.startDate);
          // dateRange.startDate = dateRange.startDate.setHours(0, 0, 0);
          dateRange.startDate = new Date(dateRange.startDate);
          dateRange.startDate = dateRange.startDate.toISOString();
          dateRange.endDate = new Date(dateRange.endDate);

          // dateRange.endDate = dateRange.endDate.setHours(23, 59, 59, 999);
          // if (dateRange.endDate > new Date()) {
          //   dateRange.endDate = new Date();
          // }
          dateRange.endDate = new Date(dateRange.endDate);
          dateRange.endDate = dateRange.endDate.toISOString();
          this.$emit("input", `${dateRange.startDate} to ${dateRange.endDate}`);
          this.dateRange = dateRange;
        } else {
          this.dateRange.startDate = new Date(this.dateRange.startDate);
          this.$emit("input", moment(this.dateRange.startDate).format("YYYY-MM-DD"));
        }
      }
    },
    updateValues(e) {
      if (e && e.startDate) {
        const selectedDateRange = `${moment(e.startDate).format("YYYY-MM-DD")} to ${moment(e.endDate).format("YYYY-MM-DD")}`;
        const date = e.startDate;
        if (!this.singleDatePicker) {
          this.$emit("input", selectedDateRange);
        } else {
          if (moment(date).isValid()) {
            this.$emit("input", moment(date).format("YYYY-MM-DD"));
          } else {
            this.$emit("input", null); // or handle it based on your requirements
          }
        }
      }
    },
    dateFormate(dateTime) {
      if (dateTime instanceof Date && !isNaN(dateTime)) {
        return moment(dateTime).format("YYYY-MM-DD");
      } else {
        return "";
      }
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/DatePicker.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.form-control.date-pickr .form-control.reportrange-text {
  height: 100%;
  line-height: 25px;
}[dir] .form-control.date-pickr .form-control.reportrange-text {
  padding: 0;
  border: none;
  background: transparent;
}
[dir] .disable-date.form-control.date-pickr .form-control.reportrange-text {
  cursor: not-allowed !important;
}
</style>
